module.exports = __webpack_public_path__ + "img/6.fafee1e4.jpg";